import type { DraftArticle } from "./AddArticleDialog"

/**
 * Group filter values, same scheme as ArticleListPanel: "" means all groups,
 * the sentinel carries no prefix and every real group name does, so no group
 * name can impersonate the "without a product group" choice.
 */
export const NO_PRODUCT_GROUP = "no-group"
const PRODUCT_GROUP_PREFIX = "group:"

export function encodeProductGroup(group: string): string {
  return `${PRODUCT_GROUP_PREFIX}${group}`
}

/** The real group name behind a choice, or null for "all" / "without group". */
export function decodeProductGroup(choice: string): string | null {
  return choice.startsWith(PRODUCT_GROUP_PREFIX)
    ? choice.slice(PRODUCT_GROUP_PREFIX.length)
    : null
}

/** Case-insensitive substring match on article number, name and the supplier's
 * own article number (so a series prefix like "SKU-12" is just a substring),
 * combined with an exact product-group match. `needle` is already lowercased. */
export function matchesArticleFilter(
  a: DraftArticle,
  needle: string,
  group: string,
): boolean {
  if (group === NO_PRODUCT_GROUP) {
    if (a.productGroup) return false
  } else if (group !== "" && a.productGroup !== decodeProductGroup(group)) {
    return false
  }
  if (needle === "") return true
  return (
    a.articleNumber.toLowerCase().includes(needle) ||
    a.name.toLowerCase().includes(needle) ||
    (a.supplierArticleNumber ?? "").toLowerCase().includes(needle)
  )
}

/** False when the name just repeats the article number (some imports store the
 * number as the name), so a row can show it once. */
export function hasDistinctName(a: {
  articleNumber: string
  name: string
}): boolean {
  const name = a.name.trim().toLowerCase()
  return name !== "" && name !== a.articleNumber.trim().toLowerCase()
}
